import styled from 'styled-components'

const Scrollable = styled.div`
  height: ${({ height }) => height}px;
  overflow-y: auto;
`

export default Scrollable



// WEBPACK FOOTER //
// ./src/components/UI/Scrollable.jsx